import { RootState } from '@reducers';

export const selectFeatureInsurerTeam = (state: RootState) => state.featureReducer.insurerTeamReducer;
